import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

// Hängt seit Umzug am gemeinsamen Firebase-Projekt mit dem zeb.bs
// Studienportal. Studis loggen sich mit ihren Portal-Zugangsdaten ein.
// Fortschritts-Daten landen NICHT in `users/{uid}` (das gehört dem
// Studienportal), sondern in der eigenen Collection
// `cybersecurityProgress/{uid}` — siehe COURSE_PROGRESS_COLLECTION.
const firebaseConfig = {
  apiKey: "AIzaSyDoAyawb1f1z43c0vdXCGq_tu_xTK5LeV8",
  authDomain: "studienportal-d307b.firebaseapp.com",
  projectId: "studienportal-d307b",
  storageBucket: "studienportal-d307b.firebasestorage.app",
  messagingSenderId: "338660897873",
  appId: "1:338660897873:web:71dc8d51ebbf4d19f6b470",
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
// Deutsche System-Mails (Passwort-Reset etc.).
auth.languageCode = "en"; // englische Vorlage ist im Studienportal-Projekt deutsch befüllt
const db = firebase.firestore();
const storage = firebase.storage();

// Name der Firestore-Collection für Lektions-Fortschritt. Bewusst
// getrennt von `users/{uid}` aus dem Studienportal, damit die Kurs-App
// keine Stammdaten anfasst.
export const COURSE_PROGRESS_COLLECTION = "cybersecurityProgress";

export { auth, db, storage };
